/**
 * Convierte a texto un item del array `message` que devuelve el backend.
 *
 * NestJS manda strings planos cuando falla el ValidationPipe, pero varios use
 * cases lanzan `BadRequestException` con objetos de dominio — por ejemplo
 * `{ idPregunta, msj }` al validar las respuestas de una presentación. Sin este
 * paso esos objetos terminan renderizados como "[object Object]".
 */
const formatErrorItem = (item: any): string => {
    if (item === null || item === undefined) return '';

    if (typeof item === 'string') return item;

    if (typeof item === 'object') {
        const texto = item.msj ?? item.message ?? item.mensaje;

        if (typeof texto === 'string') {
            return item.idPregunta ? `Pregunta ${item.idPregunta}: ${texto}` : texto;
        }

        try {
            return JSON.stringify(item);
        } catch {
            return '';
        }
    }

    return String(item);
};

export const getApiErrorMessage = (
    error: any,
    fallbackMessage: string,
    separator = ' '
): string => {
    const message = error?.data?.message ?? error?.error;

    if (Array.isArray(message)) {
        return message.map(formatErrorItem).filter(Boolean).join(separator) || fallbackMessage;
    }

    if (message && typeof message === 'object') {
        return formatErrorItem(message) || fallbackMessage;
    }

    return message || fallbackMessage;
};
